// components
import clsx from 'clsx';
import Info from '@/modules/Chat/components/Message/components/Header/components/Info';
import ChannelByIntegrationIdn from '@/components/ChannelByIntegrationIdn';
// assets
import styles from '@/modules/Chat/components/Message/components/Header/Header.module.css';

import { INTEGRATION_TO_CHANNEL } from '@/constants';

interface HeaderProps {
    className?: string;
    integrationIdn: string | null;
    connectorIdn: string | null;
    externalId: string | null;
    contactInformation: string | null;
}

const Header = ({
    className,
    integrationIdn,
    connectorIdn,
    externalId,
    contactInformation
}: HeaderProps) => {
    return (
        <header className={clsx(styles.header, className)}>
            <ChannelByIntegrationIdn
                channel={INTEGRATION_TO_CHANNEL[integrationIdn ?? '']}
            />
            <Info
                connectorIdn={connectorIdn}
                contactInformation={contactInformation}
                externalId={externalId}
                integrationIdn={integrationIdn}
            />
        </header>
    );
};

export default Header;
